import { Component, OnInit, ChangeDetectorRef, AfterContentChecked, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { map } from 'rxjs/operators';
import { FirebaseService } from 'src/app/commons/firebase.service';
import { FunctionsService } from 'src/app/data/functions.service';
import { PessoaValidador } from 'src/app/validators/pessoa-validador';
import { ConfirmationResult } from "firebase/auth";
import { UtilitariosDataService } from 'src/app/data/utilitarios-data.service';
import { SegurancaValidador } from 'src/app/validators/seguranca-validador';
@Component({
  selector: 'app-registro-cliente',
  templateUrl: './registro-cliente.component.html',
  styleUrls: ['./registro-cliente.component.css']
})

export class RegistroClienteComponent implements OnInit {
  @ViewChild('registroClienteStepper') registroClienteStepper: MatStepper;
  @Input() subtitulo: string;
  @Output() registroFinalizado = new EventEmitter();

  public clienteFormGroup: UntypedFormGroup;
  public enderecoFormGroup: UntypedFormGroup;
  public confirmacaoFormGroup: UntypedFormGroup;
  public tipoPessoa: string = 'F';
  public tiposDocumento = [{
    valor: 'rg',
    descricao: 'RG'
  }, {
    valor: 'cng',
    descricao: 'CNH'
  }, {
    valor: 'rne',
    descricao: 'RNE'
  }]
  public generos = [{
    valor: 'feminino',
    descricao: 'genero_feminino'
  }, {
    valor: 'masculino',
    descricao: 'genero_masculino'
  }, {
    valor: 'outro',
    descricao: 'genero_outro'
  }, {
    valor: 'prefiro_nao_dizer',
    descricao: 'genero_prefiro_nao_dizer'
  }]
  public loading = false;
  public confirmacao: ConfirmationResult;
  danger: boolean = false;

  constructor(
    private firebase: FirebaseService,
    private functions: FunctionsService,
    private formBuilder: UntypedFormBuilder,
    private utilitarios: UtilitariosDataService
  ) { }

  ngOnInit(): void {
    this.clienteFormGroup = this.formBuilder.group({
      cpf_cnpj: [{ value: '', disabled: false }, [
        Validators.required,
        PessoaValidador.cpfOrCnpj
      ]],
      nome: [{ value: '', disabled: false }, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(60)
      ]],
      nome_contato: [{ value: '', disabled: false }, [
        Validators.minLength(5),
        Validators.maxLength(60)
      ]],
      email: [{ value: '', disabled: false }, [
        Validators.required,
        Validators.email
      ]],
      telefone: [{ value: '', disabled: false }, [
        Validators.required
      ]],
      documento: [{ value: '', disabled: false }, [
        Validators.minLength(3)
      ]],
      tipo_documento: [{ value: '', disabled: false }, [
        Validators.required
      ]],
      genero: [{ value: '', disabled: false }, [
        Validators.required
      ]],
      senha: [{ value: '', disabled: false }, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(15)
      ]],
      confirmacao_senha: [{ value: '', disabled: false }, [
        Validators.required
      ]],
      inscricao_municipal: [{ value: '', disabled: false }, []],
      inscricao_estadual: [{ value: '', disabled: false }, []]
    }, {
      validators: [
        SegurancaValidador.confirmacaoSenha('senha', 'confirmacao_senha')
      ]
    });

    this.enderecoFormGroup = this.formBuilder.group({
      cep: [{ value: '', disabled: false }, [
        Validators.required
      ]],
      logradouro: [{ value: '', disabled: false }, [
        Validators.required
      ]],
      numero: [{ value: '', disabled: false }, [
        Validators.required
      ]],
      complemento: [{ value: '', disabled: false }, [

      ]],
      bairro: [{ value: '', disabled: false }, [
        Validators.required
      ]],
      cidade: [{ value: '', disabled: true }, [
        Validators.required
      ]],
      estado: [{ value: '', disabled: true }, [
        Validators.required
      ]],
      pais: [{value:'Brasil', disabled: true}, [
        Validators.required
      ]]
    })

    this.confirmacaoFormGroup = this.formBuilder.group({
      codigo: [{ value: '', disabled: false }, [
        Validators.required
      ]]
    });

    this.clienteFormGroup.controls['cpf_cnpj'].valueChanges.subscribe(observer => {
      if (observer.length <= 11) this.tipoPessoa = 'F';
      else this.tipoPessoa = 'J';

      if (this.tipoPessoa === 'J') {
        this.clienteFormGroup.controls['documento'].removeValidators(Validators.required)
        this.clienteFormGroup.controls['tipo_documento'].removeValidators(Validators.required)
        this.clienteFormGroup.controls['genero'].removeValidators(Validators.required);
        this.clienteFormGroup.controls['genero'].setValue('');
        this.clienteFormGroup.controls['nome_contato'].addValidators(Validators.required);
        this.clienteFormGroup.controls['inscricao_municipal'].addValidators(Validators.required);
        this.clienteFormGroup.controls['inscricao_estadual'].addValidators(Validators.required);
      } else {
        this.clienteFormGroup.controls['documento'].addValidators(Validators.required)
        this.clienteFormGroup.controls['tipo_documento'].addValidators(Validators.required)
        this.clienteFormGroup.controls['genero'].addValidators(Validators.required);
        this.clienteFormGroup.controls['nome_contato'].removeValidators(Validators.required);
        this.clienteFormGroup.controls['inscricao_municipal'].removeValidators(Validators.required);
        this.clienteFormGroup.controls['inscricao_estadual'].removeValidators(Validators.required);
      }

      this.clienteFormGroup.controls['documento'].updateValueAndValidity();
      this.clienteFormGroup.controls['tipo_documento'].updateValueAndValidity();
      this.clienteFormGroup.controls['genero'].updateValueAndValidity();
      this.clienteFormGroup.controls['nome_contato'].updateValueAndValidity();
      this.clienteFormGroup.controls['inscricao_municipal'].updateValueAndValidity();
      this.clienteFormGroup.controls['inscricao_estadual'].updateValueAndValidity();
      this.clienteFormGroup.updateValueAndValidity();


    });
  }

  buscaCep() {
    if (this.enderecoFormGroup.controls['cep'].invalid) {
      alert('Por favor, informe um CEP válido');
      return;
    }

    this.utilitarios.cep(this.enderecoFormGroup.controls['cep'].value, null).toPromise()
      .then(res => {
        console.info(res.body);
        this.convertViaCEPParaFormulario(res.body);
      })
      .catch(error => {
        console.error(error)
        alert('Não encontramos o CEP informado');
        this.convertViaCEPParaFormulario(null);
      })
  }

  proximo() {

    this.clienteFormGroup.markAllAsTouched();

    if (this.clienteFormGroup.invalid) {
      alert('Por favor, preencha corretamente todos os campos em destaque.');
      !this.clienteFormGroup.controls['tipo_documento']?.value ? this.danger = true : this.danger = true;
      return;
    }
    this.danger = false;

    if (!this.loading)
      this.registroClienteStepper.next();
  }

  anterior() {
    if (!this.loading)
      this.registroClienteStepper.previous();
  }

  login() {
    this.registroFinalizado.emit('login');
  }

  registro() {

    if (this.clienteFormGroup.invalid || this.enderecoFormGroup.invalid) {
      alert('Por favor revise os campos destacados em vermelho');
      return;
    }

    const payload: any = {
      endereco_principal: {}
    };

    Object.keys(this.clienteFormGroup.controls).forEach(key => {
      const valor = this.clienteFormGroup.controls[key].value

      if (valor === '') return;

      payload[key] = valor;
    });

    Object.keys(this.enderecoFormGroup.controls).forEach(key => {
      payload.endereco_principal[key] = this.enderecoFormGroup.controls[key].value;
    });

    this.loading = true;
    this.clienteFormGroup.disable();
    this.enderecoFormGroup.disable();

    this.functions.adicionarClientes(
      payload, null).toPromise()
      .then(res => {
        this.firebase.entrarComTelefone(
          `+55${this.clienteFormGroup.controls['telefone'].value}`
        )
          .then(res => {
            this.confirmacao = res;
            this.registroClienteStepper.next();
          })
          .catch(error => {
            alert('Ops, houve um erro ao enviar o código de acesso. Por favor, tente novamente.')
            console.error(error)
          })
          .finally(() => {
            this.loading = false;
            this.clienteFormGroup.enable();
            this.enderecoFormGroup.enable();
          })
      })
      .catch(error => {
        console.error(error);
        if (error.status === 406) {
          alert('E-mail ou telefone já cadastrado.');
        } else {
          alert('Ops, não conseguimos finalizar o seu cadastro. Por favor, tente mais tarde.');
        }
        this.loading = false;
        this.clienteFormGroup.enable();
        this.enderecoFormGroup.enable();
      })
  }

  verificarCodigoSMS() {
    if (this.confirmacaoFormGroup.invalid) {
      alert('Por favor, informe o código de verificação');
      return;
    }

    this.loading = true;
    this.confirmacaoFormGroup.disable();
    this.confirmacao.confirm(this.confirmacaoFormGroup.controls['codigo'].value)
      .then(res => {
        this.registroFinalizado.emit('finalizado');
        //** Precisa criar um fluxo para incluir o campo do usuário como confirmado */
      })
      .catch(error => {
        alert('Ops, não pudemos validar o código. Por favor, tente de novo.')
        console.error(error)
      })
      .finally(() => {
        this.confirmacaoFormGroup.enable();
        this.loading = false;
      })
  }

  convertViaCEPParaFormulario(endereco: any) {

    if (!endereco) {
      Object.keys(this.enderecoFormGroup.controls).forEach(key => {
        this.enderecoFormGroup.controls[key].setValue(null);
      });

      return;
    }

    const { cep, logradouro, bairro, cidade, estado } = this.enderecoFormGroup.controls;

    // cep.setValue(endereco.cep);
    logradouro.setValue(endereco.logradouro);
    bairro.setValue(endereco.bairro)
    cidade.setValue(endereco.localidade)
    estado.setValue(endereco.uf)
  }
}
